import React, { Fragment } from 'react';
import BottomCurve from '../../components/BottomCurve';
import HeroButton from '../../components/HeroButton';
import HeroMessage from '../../components/HeroMessage';
import HeroMessageBold from '../../components/HeroMessageBold';

function Heroslider() {
  const analyticsText = 'Holiday 2019 Banner';
  return (
    <div>
      <Fragment>
        <section className="hero">
          <div className="hero__bg">
            <div className="container">
              <div className="hero__content">
                <HeroMessage>
                  A Way Better
                  <br />
                  <HeroMessageBold>Massage Experience</HeroMessageBold>
                </HeroMessage>
              </div>
              <HeroButton />
              <BottomCurve />
            </div>
          </div>
          {/* <div className="hero__bg phone-only">
            <div className="heromobileContainer">
              <div className="hero__content">
                <Heroslidermobile />
              </div>
              <BottomCurve />
            </div>
          </div> */}
        </section>
      </Fragment>
    </div>
  );
}

Heroslider.propTypes = {};

export default Heroslider;
